(ns ui.components.query-builder.query-item
  (:require
   [common.fields.filter-types :as filter-types]
   [common.localization :as loc]
   [common.select-util :as csu]
   [common.util :as cu]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.query-builder.events :as events]
   [ui.components.select.multi-select :as multi-select]
   [ui.editors.data-input :as data-input]
   [ui.editors.labelled-input.view :as labelled-input]))

(defn field-selector
  [{:keys [rule db-path field-options menu-portal]}]
  (let
   [options (->> field-options
                 (map (fn [o]
                        (assoc o :value (:id o)))))
    opt-value (->> options
                   (map (fn [o]
                          (assoc o :value (:id o))))
                   (cu/filter-by :value (:field rule))
                   (first))]
    [data-input/view
     {:id                 (str "add-query-builder-field-" db-path)
      :editor-type        :editor.type/select
      :menu-portal-target menu-portal
      :class              "min-w-[200px]"
      :value              opt-value
      :on-change          (fn [new-value _new-opt]
                            (rf/dispatch [::events/set (concat db-path [:field]) new-value])
                            (rf/dispatch [::events/set (concat db-path [:operator]) nil])
                            (rf/dispatch [::events/set (concat db-path [:value]) nil])
                            (rf/dispatch [::events/set (concat db-path [:value-2]) nil]))
      :options            options}]))

(defn operand-selector
  [{:keys [rule db-path menu-portal query-schema]}]
  (let [field (:field rule)
        field-schema (get query-schema field)
        data-type (:data-type field-schema)
        options (->> (filter-types/data-type->filter-operators data-type)
                     (map (fn [oper]
                            {:id    oper
                             :value oper
                             :label (loc/tr oper)}))
                     (sort-by :label)
                     (vec))]
    (js/console.log "Filter options : " options
                    " \n" query-schema
                    "\n" rule
                    "\n" field
                    "\n" data-type)
    [:div
     (when (:field rule)
       [data-input/view
        {:editor-type        :editor.type/select
         :id                 (str "add-query-builder-operator-" db-path)
         :value              (->> options
                                  (cu/filter-by :value (:operator rule))
                                  (first))
         :menu-portal-target menu-portal
         :class              "min-w-[200px]"
         :placeholder        (loc/tr :select-operator)
         :on-change          #(rf/dispatch [::events/set db-path %])
         :options            options}])]))

(defn value-input
  [{:keys [rule db-path query-schema menu-portal options]}]
  (let [local-state (r/atom {})]
    (fn [{:keys [rule db-path query-schema menu-portal options]}]
      (let [rule-question-data-type (get-in query-schema [(:field rule) :data-type])
            options (when (some #{rule-question-data-type} [:data.type/ref-multi :data.type/ref-single
                                                            :data.type/keyword :data.type/keyword-multi])
                      (->> options
                           (map (fn [{:keys [id] :as opt}]
                                  (assoc opt :value id)))
                           (vec)))
            rule-value (:value rule)
            rule-operator (:operator rule)]
        (when (and (:field rule)
                   (:operator rule))
          (if (some #{rule-operator}
                    [:operand/all-of :operand/any-of :operand/none-of])
            [multi-select/view
             {:data-type          rule-question-data-type
              :menu-portal-target menu-portal
              :class              "w-[200px]"
              :value              (or (:value @local-state)
                                      (csu/value-to-opt true (:value rule) options))
              :options            options
              :on-change          (fn [v v-opt]
                                    (swap! local-state assoc :value v-opt)
                                    (rf/dispatch [::events/set db-path v]))}]
            [data-input/view
             {:data-type          rule-question-data-type
              :menu-portal-target menu-portal
              :class              (case rule-question-data-type
                                    :data.type/date "w-[250px]"
                                    :data.type/datetime "w-[250px]"
                                    "w-[150px]")
              :value              (or (:value @local-state)
                                      (if-not options
                                        rule-value
                                        (->> options
                                             (cu/filter-by :value rule-value)
                                             (first))))
              :options            options
              :on-change          (fn [v v-opt]
                                    (swap! local-state assoc :value (or v-opt v))
                                    (rf/dispatch [::events/set db-path v]))}]))))))

(defn view
  [{:keys [rule db-path rule-label] :as props}]
  (let [operator (:operator rule)]
    [:div
     {:class "flex flex-col gap-1"}
     (when rule-label
       [labelled-input/label-elem {:label rule-label}])
     [:div
      {:class "flex flex-row gap-2"}
      [field-selector props]
      [operand-selector (assoc props :db-path (concat db-path [:operator]))]
      (when-not (and (:field rule)
                     operator
                     (some #{operator} [:operand/true :operand/false :operand/known :operand/unknown]))
        [value-input (assoc props :db-path (concat db-path [:value]))])
      (when (and (:field rule)
                 (some #{(:operator rule)}
                       [:operand/between
                        :operand/between-exclusive
                        :operand/between-exclusive-date
                        :operand/between-inclusive
                        :operand/between-inclusive-date]))
        [:<>
         [:span (loc/tr :and [" " " "])]
         [value-input (assoc props :db-path (concat db-path [:value-2]))]])]]))
